export enum PlatformType {
    JIRA = "JIRA",
    OPEN_PROJECT = "OPEN_PROJECT"
}